function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0,0H16V16H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.33,14a4.65,4.65,0,0,1-2.66-.88,4.6,4.6,0,0,1-5.34,0A4.61,4.61,0,0,1,2.67,14H1.33v1.33H2.67a5.72,5.72,0,0,0,2.66-.66,5.85,5.85,0,0,0,5.34,0,5.72,5.72,0,0,0,2.66.66h1.34V14ZM2.63,12.67h0a3.62,3.62,0,0,0,2.66-1.34A3.66,3.66,0,0,0,8,12.67a3.66,3.66,0,0,0,2.67-1.34,3.64,3.64,0,0,0,2.66,1.34h0l1.26-4.46a.72.72,0,0,0,0-.52.69.69,0,0,0-.4-.33l-.86-.28V4A1.32,1.32,0,0,0,12,2.67H10v-2H6v2H4A1.32,1.32,0,0,0,2.67,4V7.08l-.86.28a.66.66,0,0,0-.44.85ZM4,4h8V6.65L8,5.33,4,6.65Z",
  fill: "#4d4d4d"
});

function SvgVessels16Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVessels16Px);
export default __webpack_public_path__ + "static/media/vessels-16px.68fb4991.svg";
export { ForwardRef as ReactComponent };